<template>
    <div class="page flex-col">
        <div class="bd1 flex-col">
            <div class="box1 flex-col">
                <img class="img1" referrerpolicy="no-referrer" src="../assets/ic_logo.png" />
                <span class="txt1">wowotown&nbsp;商家端</span>
                <div class="mod6 flex-col">
                    <div class="layer1-0 flex-col">
                        <div class="layer2-0 flex-row">
                            <div class="section1-0 flex-col"></div>
                            <input class="input_name" type="text" v-model="loginData.phone" placeholder="账号"
                                style="height: 35px; border: none" />
                        </div>
                    </div>
                    <div class="layer1-1 flex-col">
                        <div class="layer2-1 flex-row">
                            <div class="section1-1 flex-col"></div>
                            <input type="password" v-model="loginData.password" placeholder="密码"
                                style="height: 35px; border: none" />
                        </div>
                    </div>
                </div>
                <button class="mod7 flex-col" @click="change">
                    <button class="txt3">登录</button>
                </button>
            </div>
        </div>
    </div>
</template>
<script>
import Cookies from "js-cookie";
import { fetchLogin, fetchCheckMerchant } from "@/services/users";
import { Notify } from "vant";
export default {
    data() {
        return {
            loginData: {
                phone: "",
                password: "",
            },
        };
    },
    mounted() {
//         secretKey
// :
// "940db63538e64b63858ebcaa4b271619"
// token
// :
// "496c53c9cb59442a89549c3f325b4ad1_h5"

        // 判断是否存在token
        // 判断是否是否有token;
        const token = Cookies.get('token');
        this.taskApplyId = this.$route.query.id;
     if (token && token !== 'undefined' && token.includes('_')) {
            this.auth()
        }
    },
    methods: {
        change() {
            if (!this.taskApplyId) {
                Notify(
                    { type: "warning", message: "请重新扫码" });
                return;
            }
            // this.openLoading()
            const { password, phone } = this.loginData;
            if (phone === "") {
                Notify({ type: "warning", message: "手机号不能为空" });
                return false;
            }
            if (!/^1[3456789]\d{9}$/.test(phone)) {
                Notify({ type: "warning", message: "请输入正确的手机号" });
                return false;
            }
            if (password === "") {
                Notify({ type: "warning", message: "密码不能为空" });
                return false;
            }
            fetchLogin({
                password,
                phone,
            })
                .then((res) => {
                    // Cookies.remove("mini-token");
                    Cookies.set("token", res.data.token);
                    Cookies.set("secretKey", res.data.secretKey);
                    // Notify({ type: "success", message: "登录成功" });
                    this.auth();
                }).catch((error) => {
                    Notify({ type: "warning", message: "登录失败" });
                })
                .finally(() => {
                    this.closeLoading()
                });
        },
        auth() {
            fetchCheckMerchant(this.taskApplyId)
                .then((res) => {
                    if (res.data != 'false') {
                        this.$router.push({
                            path: "/confirmVerification",
                            query: {
                                id: this.taskApplyId,
                            }
                        });
                    } else {
                        Cookies.remove('token');
                        Cookies.remove('secretKey');
                        // this.$router.push("/WriteOfferror");
                        Notify({
                            type: "warning",
                            message: "无法核销",
                        })
                    }
                })
                .catch((err) => {
                    Cookies.remove('token');
                    Cookies.remove('secretKey');
                    Notify({ type: "warning", message: "验证失败，请重新登录" });
                }).finally(() => {
                    this.loading = false;
                });
        },
    },
};
</script>

<style scoped lang="less">
.page {
    z-index: 1;
    position: relative;
    width: 375px;
    //   height: 812px;
    overflow: hidden;
}

.bd1 {
    z-index: 3;
    //   height: 812px;
    // background-color: rgba(255, 255, 255, 1);
    width: 375px;
    justify-content: flex-start;
}

.box1 {
    z-index: auto;
    width: 375px;
    height: 683px;
}

.mod1 {
    z-index: 16;
    height: 44px;
    width: 375px;
    justify-content: flex-end;
    align-items: flex-end;
    padding: 0 14px 11px 0;
}

.main1 {
    z-index: auto;
    width: 340px;
    height: 17px;
}

.mod2 {
    z-index: 31;
    width: 54px;
    height: 17px;
    overflow-wrap: break-word;
    text-align: center;
    white-space: nowrap;
    font-size: 0;
}

.info1 {
    font-size: 14px;
    font-family: Helvetica, "Microsoft YaHei", Arial, sans-serif;
    color: rgba(0, 0, 0, 1);
    line-height: 17px;
    overflow: hidden;
    text-overflow: ellipsis;
}

.info2 {
    font-size: 14px;
    font-family: Helvetica, "Microsoft YaHei", Arial, sans-serif;
    color: rgba(0, 0, 0, 1);
    line-height: 17px;
    overflow: hidden;
    text-overflow: ellipsis;
}

.mod3 {
    z-index: 25;
    width: 17px;
    height: 11px;
    background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng39aeef61ebf4c04e189be0f880a1d512b1f31f81101ab4916ee829da20fbd661) -1px -1px no-repeat;
    margin: 2px 0 0 219px;
}

.mod4 {
    z-index: 21;
    width: 16px;
    height: 11px;
    background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng8b86eb1dc9460d0dbc2bca7ceceed1b7dcd69dd2157029edccb420d28cf9b047) -1px 0px no-repeat;
    margin: 2px 0 0 5px;
}

.label1 {
    z-index: 17;
    width: 25px;
    height: 12px;
    margin: 1px 0 0 4px;
}

.img1 {
    z-index: 44;
    width: 60px;
    height: 60px;
    align-self: center;
    margin-top: 108px;
}

.txt1 {
    z-index: 42;
    width: 89px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(109, 114, 120, 1);
    font-size: 14px;
    letter-spacing: -0.26250001788139343px;
    font-family: PingFangSC-Regular;
    white-space: nowrap;
    line-height: 20px;
    text-align: left;
    align-self: center;
    margin-top: 15px;
}

.mod6 {
    z-index: auto;
    width: 335px;
    height: 125px;
    margin: 44px 0 0 20px;
}

.layer1-0 {
    z-index: 4;
    height: 54px;
    margin-bottom: 18px;
    width: 335px;
    justify-content: center;
    align-items: flex-start;
    padding-left: 16px;
    // background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngde540fd5c6f12088a299f2723349e5038dc9e4dea3952238eb9c419420e420c7)
    //     100% no-repeat;
    border: 1px solid #d8d8d8;
    border-radius: 10px;
}

.layer2-0 {
    z-index: auto;
    width: 65px;
    height: 25px;
    justify-content: space-between;
}

.section1-0 {
    z-index: 46;
    width: 24px;
    height: 30px;
    background: url("../assets/zx/r.png") 0px 0px no-repeat;
}

.txt2-0 {
    z-index: 34;
    width: 28px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(109, 114, 120, 1);
    font-size: 14px;
    letter-spacing: -0.26250001788139343px;
    font-family: PingFangSC-Regular;
    white-space: nowrap;
    line-height: 20px;
    text-align: left;
    margin-top: 2px;
}

.layer1-1 {
    z-index: 4;
    height: 54px;
    margin-bottom: 18px;
    width: 335px;
    justify-content: center;
    align-items: flex-start;
    padding-left: 16px;
    border: 1px solid #d8d8d8;
    border-radius: 10px;
    // background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngde540fd5c6f12088a299f2723349e5038dc9e4dea3952238eb9c419420e420c7)
    //     100% no-repeat;
}

.layer2-1 {
    z-index: auto;
    width: 65px;
    height: 25px;
    justify-content: space-between;
}

.section1-1 {
    z-index: 46;
    width: 24px;
    height: 30px;
    background: url("../assets/zx/suo.png") -1px 0px no-repeat;
}

.txt2-1 {
    z-index: 34;
    width: 28px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(109, 114, 120, 1);
    font-size: 14px;
    letter-spacing: -0.26250001788139343px;
    font-family: PingFangSC-Regular;
    white-space: nowrap;
    line-height: 20px;
    text-align: left;
    margin-top: 2px;
}

.mod7 {
    z-index: 12;
    height: 50px;
    border-radius: 25px;
    background: #17c2cf;
    align-self: center;
    margin-top: 181px;
    width: 245px;
    justify-content: center;
    align-items: center;
}

.txt3 {
    z-index: 13;
    width: 32px;
    display: block;
    overflow-wrap: break-word;
    color: #ffffff;
    font-size: 16px;
    font-family: PingFangSC-Medium;
    white-space: nowrap;
    line-height: 22px;
    text-align: center;
}

body * {
    box-sizing: border-box;
    flex-shrink: 0;
}

body {
    font-family: PingFangSC-Regular, Roboto, Helvetica Neue, Helvetica, Tahoma,
        Arial, PingFang SC-Light, Microsoft YaHei;
}

button {
    margin: 0;
    padding: 0;
    border: 1px solid transparent;
    outline: none;
    background-color: transparent;
}

button:active {
    opacity: 0.6;
}

.flex-col {
    display: flex;
    flex-direction: column;
}

.flex-row {
    display: flex;
    flex-direction: row;
}
</style>
